/**
 * Who may WRITE on the discount screens -- phase 6b, Task 1.
 *
 * Reads the same role source CustomMenu.tsx reads (`usePermissions().role`
 * from context/PermissionContext) and applies CustomMenu's own
 * `isOwnerOrAdmin` rule (`role === 'owner' || role === 'admin'`). The API
 * enforces `update:any discount` regardless (403); the UI just does not
 * render buttons that would 403. Reads are open to every role that can see
 * the menu group (owner/admin/marketing/manager/staff).
 */
import { usePermissions } from '../../context/PermissionContext';

// Staff: the discount pages are theirs only when ticked (Jason, 31 Oct 2026)
export const canWriteDiscounts = (role: string | null | undefined): boolean => role === 'owner' || role === 'admin' || role === 'staff';

export function useCanWriteDiscounts(): boolean {
  const { role } = usePermissions();
  return canWriteDiscounts(role);
}

/**
 * `GET admin/users/customers/search` runs `assertAdminAccess` on the backend
 * (owner/admin only), so the customer SEARCH box is a write-role control
 * too; read-only roles get a paste-an-id field with this hint instead.
 */
export const CUSTOMER_SEARCH_RESTRICTED_HINT =
  "Search is available to owners and admins. Paste a customer id, or open a customer from a promotion's Redemptions tab.";
